"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isObjectLike=function(e){return"object"==typeof e&&null!==e};
//# sourceMappingURL=isObjectLike.mjs.js.map
